<div (click)="closeCallback()" class="relative cursor-pointer overflow-hidden">
  <div class="relative bg-primary w-full rounded-full pt-3 pb-3 text-center overflow-hidden">
    <div
      [style.animation-duration]="delayInSeconds + 's'"
      class="absolute bg-[#A7D04D] animate-autoClosedButton w-full h-full top-0 bottom-0 left-0 right-0"
    ></div>
    <p class="relative text-sm font-bold text-secondary">
      {{ text }}
    </p>
  </div>
</div>
